<template>
  <recruit028 />
</template>

<script>
import recruit028 from '@/pages/recruit/p_recruit028.vue';

export default {
  components: {
    recruit028
  }
};
</script>
